<template>
  <card-item
    card="item_subtheme"
    :tabs="tabs"
    :activeTab="activeTab"
    :id="id"
    :infoKeys="infoKeys"
  />
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          key: "information_card",
          component: () => import("./Info"),
        },
        {
          title: "Ресурсы",
          component: () => import("./LessonplanResource"),
          key: "resources",
        },
        {
          title: "Задания",
          component: () => import("./LessonplanWork"),
          key: "tasks",
        },
        {
          title: "Доп. материалы",
          component: () => import("./LessonplanMedia"),
          key: "additional_material",
        },
      ],
      activeTab: 0,
      infoKeys: [
        {
          key: "title",
          title: "Плановый урок",
        },
        {
          key: "locale",
          title: "Локализация контента",
        },
        {
          key: "position",
          object: "course",
          title: "Класс",
        },
        {
          key: "title",
          object: "discipline",
          title: "Предмет",
        },
      ],
    };
  },
};
</script>